import React from 'react';
import { PageShell } from '../components/pages/PageShell';
import { ContentIntro } from '../components/pages/ContentIntro';
import { ContentBody } from '../components/pages/ContentBody';
import { ContentFaq } from '../components/pages/ContentFaq';
import { RelatedPages } from '../components/pages/RelatedPages';
import { ContentCTA } from '../components/pages/ContentCTA';
import type { PageContent } from '../types/pageContent';
export function contentBreadcrumbs(page: PageContent) {
  const section = page.kind === 'service' ? {
    label: 'Services',
    path: '/commercial-truck-body-repair-services'
  } : page.kind === 'guide' ? {
    label: 'Resources',
    path: '/repair-guides'
  } : null;
  return [{
    label: 'Home',
    path: '/'
  }, ...(section ? [section] : []), {
    label: page.navLabel,
    path: page.path
  }];
}
export function ServiceContentPage({
  page
}: {
  page: PageContent;
}) {
  return <PageShell data-id="element-535" data-mp="2q1twen6gcqjy"><ContentIntro page={page} breadcrumbs={contentBreadcrumbs(page)} data-id="element-536" data-mp="2q1k2wpm7819i" /><ContentBody page={page} data-id="element-537" data-mp="2pzqvh83rhd0g" />
    <ContentFaq faqs={page.faqs || []} data-id="element-538" data-mp="3a63a9hgy5jy9" /><RelatedPages links={page.related || []} data-id="element-539" data-mp="3a51nwguhdb18" /><ContentCTA data-id="element-540" data-mp="3a85xxuumn0zt" /></PageShell>;
}